import { ITruncate } from "Interfaces/interface.uiUtils";
import React from "react";

const Truncate: React.FC<ITruncate> = ({
  text,
  maxLength,
  className = "",
  tooltip = false,
}) => {
  const truncated =
    text.length > maxLength ? text.slice(0, maxLength) + "…" : text;

  return (
    <span
      className={className}
      title={tooltip && text.length > maxLength ? text : undefined}
    >
      {truncated}
    </span>
  );
};

export default Truncate;
